<template>
  <main class="page">
    <section class="page__intro page__intro--left">
      <h1 class="page__title page__title--green">Mina tillgångar</h1>
      <h2>Alla dina tillgångar samlade på ett ställe.</h2>
      <p>Målet är att koppla ihop alla dina tillgångar hos alla aktörer där du är kund automatiskt. Vi verifierar detta även via dina egna angivna uppgifter nedan.</p>
    </section>
    <div class="page__main">
      <section class="settings__message">
        <transition name="fade">
          <p :key="message" v-show="message !== ''">
            {{ message }}
          </p>
        </transition>
      </section>
      <section class="item">
        <SettingsItem v-for="(data,index) in settingsData" :key="index" :setting="data"/>
      </section>
    </div>
  </main>
</template>

<script>
import { SettingsItem, LoadingSpinner } from '../components/';
import { mapGetters } from 'vuex';

export default {
  name: 'Assets',
  data() {
    return {
      message: ''
    }
  },
  components: {
    SettingsItem, LoadingSpinner
  },
  computed: {
    ...mapGetters([ 'user' ]),
    settingsData () {
      let access = this.user.access;

      return ([
        {
          "title": "Fastigheter",
          'field': "realEstate",
          "firstValue": access.realEstate.value,
          "secondValue": access.realEstate.increaseInValue,
          "labelOne": "Fastighetsvärdering",
          "labelTwo": "Beräknad årlig värdeökning"
        },
        {
          "title": "Fordon",
          "field": "vehicle",
          "firstValue": access.vehicle.value,
          "secondValue": access.vehicle.increaseInValue,
          "labelOne": "Bilar och motorcyklar",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
        {
          "title": "Båt",
          "field": "boat",
          "firstValue": access.boat.value,
          "secondValue": access.boat.increaseInValue,
          "labelOne": "Sjöfordon",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
        {
          "title": "Övrigt",
          "field": "other",
          "firstValue": access.other.value,
          "secondValue": access.other.increaseInValue,
          "labelOne": "Konst och värdeföremål",
          "labelTwo": "Beräknad årlig värdeförändring"
        },
        {
          "title": "Lönekonto",
          "field": "account",
          "firstValue": access.account.value,
          "secondValue": access.account.increaseInValue,
          "labelOne": "Nuvarande",
          "labelTwo": "Ökning"
        },
        {
          "title": "Sparkonto / ISK",
          "field": "savingsAccount",
          "firstValue": access.savingsAccount.value,
          "secondValue": access.savingsAccount.increaseInValue,
          "labelOne": "Nuvarande",
          "labelTwo": "Ökning"
        },
        {
          "title": "Lån",
          "field": "loan",
          "firstValue": access.loan.value,
          "secondValue": access.loan.increaseInValue,
          "labelOne": "Nuvarande",
          "labelTwo": "Ränta"
        },
      ])
    }
  },
}
</script>

<style lang="scss" scoped>
.item {
  > div:last-of-type {
    margin-bottom: 0;
  }
}
</style>